// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glyph-NRTZsc,.custom-W0tPND{border-radius:var(--abr-radius-md,6px);flex-shrink:0;display:block}.custom-W0tPND{-o-object-fit:cover;object-fit:cover}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"glyph": `glyph-NRTZsc`,
	"custom": `custom-W0tPND`
};
export default ___CSS_LOADER_EXPORT___;
